export default __webpack_public_path__ + "static/media/img-logo-mongodb.26dc0df6.svg";